var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-levels-assessment-mobile-placeholder"},[_c('ContentPlaceholders',_vm._l((5),function(i){return _c('ContentPlaceholdersImg',{key:i,staticClass:"category-levels-assessment-mobile-placeholder__card"})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }